module.exports = __webpack_public_path__ + "media/coffee-preferences/brew_method_aeropress-7dd390db.png";